import React from 'react';
import { Download, Image as ImageIcon, Loader2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import './ToolCanvas.css';
import { Upload } from 'lucide-react';

// ★ IMPORT THE NEW COMPONENT ★
import SideBySideCanvas from './SideBySideCanvas';

const ToolCanvas = ({ 
    imageSrc,          // Result Image
    originalSrc,       // Original Image
    isLoading, 
    loadingMessage,    
    isEmpty, 
    onDownload,
    layoutMode = 'slider', // 'slider' OR 'side-by-side'
    onUpload 
}) => {
    // FIX: Hooks inside function
    const [sliderPos, setSliderPos] = React.useState(50);

    // --- EMPTY STATE ---
    if (isEmpty && !isLoading) {
        return (
            <div className="tool-canvas-wrapper">
                <div className="transparency-grid-layer centered-layout">
                    <div className="empty-state-content">
                        <div className="empty-icon-circle">
                            <ImageIcon size={48} strokeWidth={1.5} />
                        </div>
                        <h3>Upload an image to get started</h3>
                        <p>Your processed result will appear here.</p>
                        
                        {/* ★ NEW BUTTON HERE ★ */}
                        {onUpload && (
                            <label className="btn-canvas-upload">
                                <Upload size={18} />
                                <span>Upload Image</span>
                                <input 
                                    type="file" 
                                    hidden 
                                    accept="image/*"
                                    onChange={(e) => onUpload(e.target.files[0])} 
                                />
                            </label>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="tool-canvas-wrapper">
            <div className="transparency-grid-layer centered-layout">
                <AnimatePresence mode="wait">
                    {isLoading ? (
                        <motion.div className="canvas-loader" initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}} key="loader">
                            <div className="loader-box">
                                <Loader2 size={40} className="spin" />
                                <h3>Processing...</h3>
                                {loadingMessage && <p className="did-you-know"><span className="fact-label">Did you know:</span> {loadingMessage}</p>}
                            </div>
                        </motion.div>
                    ) : (
                        <motion.div 
                            className="canvas-media-container"
                            initial={{opacity:0, scale:0.98}} animate={{opacity:1, scale:1}} transition={{duration:0.3}} key="media"
                        >
                            
                            {/* === LAYOUT A: SIDE-BY-SIDE (New) === */}
                            {layoutMode === 'side-by-side' && imageSrc && originalSrc ? (
                                <SideBySideCanvas 
                                    originalSrc={originalSrc}
                                    resultSrc={imageSrc}
                                    onDownload={onDownload}
                                />
                            ) : 
                            
                            /* === LAYOUT B: SLIDER (Default) === */
                            (imageSrc && originalSrc) ? (
                                <div className="slider-wrapper-strict">
                                    <span className="canvas-badge badge-before">Before</span>
                                    <span className="canvas-badge badge-after">After</span>

                                    <img src={imageSrc} alt="Result" className="slider-layer layer-after" />
                                    <img src={originalSrc} alt="Original" className="slider-layer layer-before" style={{ clipPath: `inset(0 ${100 - sliderPos}% 0 0)` }} />

                                    <div className="slider-line" style={{ left: `${sliderPos}%` }}>
                                        <div className="slider-button"><div className="chevron-left" /><div className="chevron-right" /></div>
                                    </div>
                                    <input type="range" min="0" max="100" value={sliderPos} onChange={(e) => setSliderPos(e.target.value)} className="invisible-slider-input" />
                                </div>
                            ) : (
                                /* SINGLE IMAGE FALLBACK */
                                <img src={imageSrc || originalSrc} alt="Canvas Content" className="single-image-strict" draggable={false} />
                            )}

                            {/* Slider Download Button (SideBySide has its own) */}
                            {layoutMode === 'slider' && imageSrc && onDownload && (
                                <div className="canvas-actions-bottom">
                                    <button onClick={onDownload} className="btn-download-float">
                                        <Download size={18} /><span>Download Result</span>
                                    </button>
                                </div>
                            )}
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>
        </div>
    );
};

export default ToolCanvas;